<div class="variant-item-container" (click)="selectVariant()">
  <div class="content  {{ variant.isActive ? 'active' : '' }}">
    <div class="name">
      {{ variant.name }}
    </div>
  </div>
</div>
